import { FieldQueryOptions } from '@cibo/core'
import { useOrgUser } from '@cibo/profile'
import { FilterChip, useParamAsInteger } from '@cibo/ui'
import { Box, Paper, Stack } from '@mui/material'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { PaginatedFieldsContext } from '../../PaginatedFieldsProvider'
import { filterCount } from '../filterCount'
import { FilterChipComponents, FilterChipName } from './FilterChipComponents'

const filterPresentationOrder: FilterChipName[] = [
  'fdrStatusAnyOf',
  'cashCrop',
  'coverCrop',
  'tillage',
  'fips',
  'acresLt',
  'acresGt',
  'grower',
  'owner',
  'termsets',
  'labels',
  'lastUpdatedGt',
  'lastUpdatedLt',
]

export const FieldSearchChips = ({ hideBackground = false }: { hideBackground?: boolean }) => {
  const { t } = useTranslation('@cibo/landmanager/FieldSearchBar')
  const userId = useParamAsInteger('userId')
  const { data: routedUserScope } = useOrgUser(userId)

  const { filters, setFilters, hideFilters } = useContext(PaginatedFieldsContext)

  const handleUpdate = (newFilters: FieldQueryOptions) => {
    setFilters(newFilters)
  }

  if (filterCount(filters) === 0 && (!routedUserScope || hideFilters['userId'])) {
    return null
  }

  return (
    <Paper
      elevation={0}
      sx={{ backgroundColor: hideBackground ? 'transparent' : 'background.default' }}
    >
      <Stack
        direction="row"
        spacing={1.5}
        flexWrap="wrap"
        alignItems="start"
        sx={{
          width: '100%',
          mb: 1.5,
        }}
      >
        {/* this box element exists to force correct spacing on wrapping instances of the chips */}
        <Box sx={{ width: 1.5 }} />
        {filterPresentationOrder.map(filterName => {
          const FilterChipComponent = FilterChipComponents[filterName]

          if (hideFilters[filterName]) {
            return null
          }

          return (
            <FilterChipComponent
              filters={filters}
              handleUpdate={handleUpdate}
              t={t}
              key={filterName}
            />
          )
        })}

        {!!routedUserScope && !hideFilters['userId'] && (
          <FilterChip label={routedUserScope.displayNameFull} />
        )}
      </Stack>
    </Paper>
  )
}
